import { apiHelper, PromiseHandler } from "../redux/apiHelper";
const deleteLogsById = (id) =>
  PromiseHandler(apiHelper("post", `/api/admin/adminlogs/delete/${id}`));
const getLogs = () => PromiseHandler(apiHelper("get", "/api/admin/adminlogs/list"));
const getLogsById = (id) =>
  PromiseHandler(apiHelper("get", `/api/admin/adminlogs/get/${id}`));
export { deleteLogsById, getLogs, getLogsById };
